import { linkToDashboard } from "features/dashboard/links";
import { NAV_ITEMS_BASE_STUDENT } from "features/navbar/consts";
import { NavItemLink } from "features/navbar/types";

const home: NavItemLink = {
  ...NAV_ITEMS_BASE_STUDENT.home,
  to: linkToDashboard()
};

export default home;
